import { render, staticRenderFns } from "./DialogPetitionRequestOneplateform.vue?vue&type=template&id=0d59d3b4&"
import script from "./DialogPetitionRequestOneplateform.vue?vue&type=script&lang=js&"
export * from "./DialogPetitionRequestOneplateform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports